const isBrowser = typeof window !== "undefined";

// Read each variable explicitly so webpack DefinePlugin can inline build-time values.
// Avoid `process.env` as a whole object — runtime polyfills may supply an empty env.
const env = {
  NODE_ENV: process.env.NODE_ENV,
  PLATFORM_ENV: process.env.PLATFORM_ENV,
  VENDOR: process.env.VENDOR,
  TARGET_ENV: process.env.TARGET_ENV,
  CONFIG_ENV_KEY: process.env.CONFIG_ENV_KEY,
  CONFIG_VENDOR_KEY: process.env.CONFIG_VENDOR_KEY,
  WEBPACK_BUNDLE: process.env.WEBPACK_BUNDLE,
  WEBPACK_BUILD: process.env.WEBPACK_BUILD,
  STAGING_ACCESS_TOKEN: process.env.STAGING_ACCESS_TOKEN,
  PUBLIC_URL: process.env.PUBLIC_URL,
  HTTPS_PROXY: process.env.HTTPS_PROXY,
  https_proxy: process.env.https_proxy,
  HTTP_PROXY: process.env.HTTP_PROXY,
  http_proxy: process.env.http_proxy
};

const isWebEnv = env.PLATFORM_ENV === "web";

if (!isWebEnv) {
  try {
    const ExpoConstantsModule = require("expo-constants");
    const ExpoConstants = ExpoConstantsModule && ExpoConstantsModule.default;
    const expoExtra = ExpoConstants?.expoConfig?.extra || {};

    Object.assign(env, expoExtra);
  } catch (error) {
    // On web/Storybook builds `expo-constants` can be mocked/empty.
  }
}

if (isBrowser) {
  env.PLATFORM_ENV = env.PLATFORM_ENV || "web";
  env.VENDOR = env.VENDOR || "squaber";

  if (!env.TARGET_ENV) {
    // Prefer production over development when NODE_ENV is production — CI web bundles
    // do not include gitignored `*_development.js` config modules.
    env.TARGET_ENV =
      env.NODE_ENV === "production" ? env.NODE_ENV || "production" : "development";
  }
}

export default env;
